import { render, staticRenderFns } from "./configlist.vue?vue&type=template&id=de0c293a&scoped=true&"
import script from "./configlist.vue?vue&type=script&lang=js&"
export * from "./configlist.vue?vue&type=script&lang=js&"
import style0 from "./configlist.vue?vue&type=style&index=0&id=de0c293a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0c293a",
  null
  
)

export default component.exports